import React, { Component } from 'react';
import { Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';

class GenericSearcher extends Component {
    onKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.onSearch();
        }
    }

    render() {
        return (
            <div>
              <InputGroup>
                <Input onChange={(event) => this.props.onChange(event.target.value)}
                       value={this.props.searchTerms}
                       onKeyPress={(e) => this.onKeyPress(e)}
                       id="search-input"
                  placeholder={this.props.placeHolder} className="tag-input"/>
                  <InputGroupAddon addonType="append">
                    <Button onClick={() => this.props.onSearch()} color="secondary">Search</Button>
                  </InputGroupAddon>
              </InputGroup>
            </div>
        );
    }
}

export default GenericSearcher;
